import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip } from '@upsales/components';

import PropTypes from 'prop-types';
import { globalTracker } from 'App/babel/helpers/Tracker';
import TableHeaderDropdown from 'Components/MultiSelect/TableHeaderDropdown';
import ReactCreateClass from 'create-react-class';
import AppService from 'App/legacy/AppService';
import { isCustom, isCategory, isAddress, parseNested } from 'App/helpers/filterHelper';
// Aliased: `useIcon` reads as a React hook to eslint's rules-of-hooks, and these are not components.
import { getAddress, getCustomConfig, useIcon as getColumnIcon } from 'App/helpers/filterHelperInstances';
import Elevio from 'App/babel/components/LegacyReactTemplates/elevio';

const propTypes = {
	tools: PropTypes.shape({
		sort: PropTypes.func,
		opts: PropTypes.object,
		$multiSelect: PropTypes.shape({
			getTotal: PropTypes.func,
			allSelected: PropTypes.bool,
			selectArray: PropTypes.func,
			selectAllFilter: PropTypes.func,
			selectNone: PropTypes.func,
			selected: PropTypes.array,
			allSelectedFilter: PropTypes.bool
		})
	}),
	actions: PropTypes.shape({
		runAction: PropTypes.func,
		actions: PropTypes.any
	}),
	data: PropTypes.array,
	template: PropTypes.string,
	loading: PropTypes.bool,
	length: PropTypes.number,
	columns: PropTypes.arrayOf(PropTypes.string),
	categoryTypes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	),
	columnTemplates: PropTypes.object,
	currentSorting: PropTypes.shape({
		ascending: PropTypes.bool,
		attribute: PropTypes.string
	})
};

var sortIconMap = {
	number: {
		asc: 'Icon-sort-numeric-asc',
		desc: 'Icon-sort-numeric-desc'
	},
	date: {
		asc: 'Icon-sort-numeric-asc',
		desc: 'Icon-sort-numeric-desc'
	},
	string: {
		asc: 'Icon-sort-alpha-asc',
		desc: 'Icon-sort-alpha-desc'
	},
	none: {
		asc: 'Icon-sort-amount-asc',
		desc: 'Icon-sort-amount-desc'
	}
};

const TableTH = ReactCreateClass({
	displayName: 'TableTH',
	classes: {
		none: 'Icon-sort'
	},
	generateState: function () {
		var isSorted = this.props.currentSorting && this.props.currentSorting.attribute === this.props.column.sortable;
		var datatype = (this.props.column.displayType || this.props.column.type || '').toLowerCase();
		var className = this.classes.none;
		if (isSorted) {
			var sortType = sortIconMap[datatype] || sortIconMap.none;
			className = sortType[this.props.currentSorting.ascending ? 'asc' : 'desc'];
		}
		return {
			isSorted: isSorted,
			asc: this.props.currentSorting ? this.props.currentSorting.ascending : false,
			class: className
		};
	},
	getInitialState: function () {
		return this.generateState();
	},
	resizeTimeout: null,
	resizeThrottler: function () {
		var self = this;

		if (!self.resizeTimeout) {
			self.resizeTimeout = setTimeout(function () {
				self.resizeTimeout = null;
				self.setWidth();
			}, 66);
		}
	},
	componentDidMount: function () {
		this.setClasses();

		var tableElement = this._th.parentNode.parentNode.parentNode;

		if (tableElement.classList.contains('fixed')) {
			window.addEventListener('resize', this.resizeThrottler);
			this.setWidth();
		}
		this.setWidth();
	},
	componentWillUnmount: function () {
		var tableElement = this._th.parentNode.parentNode.parentNode;
		if (tableElement.classList.contains('fixed')) {
			window.removeEventListener('resize', this.resizeThrottler);
		}
	},
	componentDidUpdate: function () {
		this.state = this.generateState();

		this.setClasses();

		var tableElement = this._th.parentNode.parentNode.parentNode;
		if (tableElement.classList.contains('fixed')) {
			this.setWidth();
		}
		this.setWidth();
	},
	click: function () {
		var column = this.props.column;
		if (column.sortable) {
			var sortOrder;
			if (this.state.isSorted) {
				sortOrder = !this.state.asc;
			} else {
				// If ASC is true or false
				sortOrder = column.type === 'String' ? true : false;
			}
			this.props.sort(this.props.column.sortable, sortOrder);
		}
	},
	setWidth: function () {
		var column = this.props.column;
		var icon = getColumnIcon(column.title);

		if (this.props.tools.opts.type === 'order') {
			var self = this;
			setTimeout(function () {
				var th = $(ReactDOM.findDOMNode(self.refs['th']));
				var colElem = $(ReactDOM.findDOMNode(self.refs['column']));

				if (icon) {
					th.css('min-width', Math.max(colElem.outerWidth() + 15, 50));
				} else {
					th.css('min-width', Math.max(colElem.outerWidth() + 15, column.minWidth || 100));
				}
			}, 0);
		} else {
			var th = $(ReactDOM.findDOMNode(this._th));
			var colElem = $(ReactDOM.findDOMNode(this._column));

			if (icon) {
				th.css('min-width', Math.max(colElem.outerWidth() + 15, 50));
			} else {
				th.css('min-width', Math.max(colElem.outerWidth() + 15, column.minWidth || 100));
			}
		}
	},
	setClasses: function () {
		var colElem = $(ReactDOM.findDOMNode(this._column));
		var indicatorElem = $(ReactDOM.findDOMNode(this._indicator));

		if (this.state.isSorted) {
			colElem.addClass('sorted');
		} else {
			colElem.removeClass('sorted');
		}

		indicatorElem.removeClass(
			Object.values(sortIconMap)
				.reduce(function (out, v) {
					return out.concat(Object.values(v));
				}, [])
				.join(' ')
		);
		indicatorElem.addClass(this.state.class);
	},
	render: function () {
		var tools = this.props.tools;
		var column = this.props.column;
		var indicator = '';
		var classNames = 'th-inner';

		let title = typeof column.displayText === 'function' ? column.displayText() : column.title;
		title = tools.$translate(title);
		var icon = getColumnIcon(column.title);

		if (title && title.length > 20) {
			title = title.substr(0, 20) + '...';
		}

		var thStyle = {};

		if (icon) {
			title = (
				<Tooltip title={tools.$translate(icon.tooltip)} position="top">
					<span className={icon.icon} />
				</Tooltip>
			);

			thStyle.minWidth = '50px';
		}

		if (column.sortable) {
			var style = { paddingLeft: '5px' };
			classNames += ' sortable-header';
			indicator = (
				<span
					ref={el => {
						this._indicator = el;
					}}
					className="Icon sorting-indicator"
					style={style}
				/>
			);
		}

		var tdClass = 'table-column sortable column-' + column.field;

		var elevioId = null;
		if (column.elevioId) {
			elevioId = (
				<span>
					{' '}
					<Elevio articleId={column.elevioId} />
				</span>
			);
		} else {
			elevioId = '';
		}

		return (
			<th
				ref={el => {
					this._th = el;
				}}
				key={'column-' + column.title}
				className={tdClass}
				style={thStyle}
			>
				<div
					ref={el => {
						this._column = el;
					}}
					className={classNames}
					onClick={this.click}
				>
					{title}
					{elevioId}
					{indicator}
				</div>
			</th>
		);
	}
});

class TableHead extends Component {
	static propTypes = propTypes;

	closeMultiSelect = () => {
		$(ReactDOM.findDOMNode(this._dropdown)).removeClass('open').click();
		$('body').trigger('click');
	};

	sort = (attr, asc) => {
		this.props.tools.sort({ attribute: attr, ascending: asc });
	};

	selectAll = () => {
		this.closeMultiSelect();
		//this.props.tools.$multiSelect.selectAll(true);
		var idField = this.props.tools.opts.idField || 'id';
		var total = this.props.tools.$multiSelect.getTotal();
		var selected = _.pluck(this.props.data, idField);

		if (selected.length === total) {
			this.props.tools.$multiSelect.allSelected = true;
		}

		this.props.tools.$multiSelect.selectArray(selected);
	};

	selectAllFilter = () => {
		this.closeMultiSelect();
		this.props.tools.$multiSelect.selectAllFilter();
	};

	selectNone = () => {
		this.closeMultiSelect();
		this.props.tools.$multiSelect.selectNone();
	};

	selectToggle = () => {
		if (this.props.tools.$multiSelect.allSelected) {
			this.selectNone();
		} else {
			this.selectAll();
		}
	};

	getClass = () => {
		var toggleClass = '';
		if (!this.props.tools.$multiSelect.allSelected && this.props.tools.$multiSelect.selected.length) {
			toggleClass = 'Icon-minus-square-o';
		} else if (this.props.tools.$multiSelect.allSelected || this.props.tools.$multiSelect.allSelectedFilter) {
			toggleClass = 'Icon-check-square';
		} else {
			toggleClass = 'Icon-square-o';
		}
		return toggleClass;
	};

	setClasses = () => {
		var btn = $(ReactDOM.findDOMNode(this._indicator));
		btn.removeClass('fa-square-o fa-minus-square-o fa-check-square');
		var toggleClass = this.getClass();
		btn.addClass(toggleClass);
	};

	doExport = options => {
		if (options.selectAllFilter) {
			this.selectAllFilter();
		} else {
			this.selectAll();
		}
		var self = this;

		globalTracker.track('experimental-export-button', { type: this.props.tools.opts.type, location: 'list' });
		return this.props.actions.runAction(this.props.actions.actions.export).finally(function () {
			self.props.tools.$multiSelect.selectNone();
		});
	};

	componentDidMount() {
		this.unsubSelectAll = Tools.$rootScope.$on('$multiSelect.selectAll', this.setClasses);
		this.unsubSelectAllFilter = Tools.$rootScope.$on('$multiSelect.selectAllFilter', this.setClasses);
		this.unsubSelectNone = Tools.$rootScope.$on('$multiSelect.selectNone', this.setClasses);
		this.unsubToggle = Tools.$rootScope.$on('$multiSelect.toggle', this.setClasses);
	}

	componentWillUnmount() {
		this.unsubSelectAll();
		this.unsubSelectAllFilter();
		this.unsubSelectNone();
		this.unsubToggle();
	}

	render() {
		var tools = this.props.tools;
		var classes = this.getClass();
		var total = tools.$multiSelect.getTotal();
		var canExport = AppService.getSelf().export;
		var hasData = (this.props.data || []).length;
		var hasExportAction = this.props.actions && this.props.actions.actions && this.props.actions.actions.export;
		var hasExport = !!(hasData && canExport);
		var toolsColumnClasses = this.props.template === 'leadRow' ? 'column-tools column-tools-sm' : 'column-tools';
		if (this.props.template === 'activityRow') {
			toolsColumnClasses += ' responsive';
		}
		var checkAllElem = null;

		var defaultOptions = {
			selectNone: true,
			selectAll: true,
			selectAllFilter: true
		};

		var options = tools.opts.multiSelectOptions || defaultOptions;

		var selectOptions = [];

		if (options.selectAllFilter) {
			var text = Tools.$translate('default.selectAll');
			if (total !== undefined && total !== null && !this.props.loading) {
				var displayTotal = total;

				if (tools && tools.$filter) {
					var numberFormat = tools.$filter('numberFormat');
					displayTotal = numberFormat(displayTotal);
				}

				text = text + ' (' + displayTotal + ')';
			}

			selectOptions.push({ onClick: this.selectAllFilter, text });
		}
		if (options.selectAll) {
			selectOptions.push({ onClick: this.selectAll, text: Tools.$translate('default.selectAllOnPage') });
		}
		if (options.selectNone) {
			selectOptions.push({ onClick: this.selectNone, text: Tools.$translate('default.deselectAll') });
		}

		if (this.props.length === total) {
			checkAllElem = (
				<div id="check-btn" className="btn btn-sm" disabled={!total ? true : false} onClick={this.selectToggle}>
					<b
						className={'Icon ' + classes}
						ref={el => {
							this._indicator = el;
						}}
					/>
				</div>
			);
		} else {
			checkAllElem = (
				<TableHeaderDropdown
					items={selectOptions}
					selected={tools.$multiSelect.allSelected || tools.$multiSelect.allSelectedFilter}
				/>
			);
		}

		return (
			<thead>
				<tr>
					{tools.opts.hasCheck ? (
						<th className="checkbox-column" key="th-check">
							<div className="th-inner">{checkAllElem}</div>
						</th>
					) : null}

					{this.props.columns.map(
						function (key) {
							var column;
							if (isCustom(key)) {
								column = getCustomConfig(key, tools.customFields);
								column.sortable = key;
							} else if (isCategory(key)) {
								var category = _.find(this.props.categoryTypes, { id: parseInt(key.split('_')[1]) });
								column = {
									title: category ? category.name : '',
									field: key
								};
							} else if (parseNested(key)) {
								column = {
									title: 'nested.' + parseNested(key).child,
									field: key,
									sortable: key
								};
							} else if (isAddress(key)) {
								var address = getAddress(key);
								var fields = address.title.split('.');
								var type = fields.length === 3 ? fields[2] : fields[1];
								var field = fields.length === 3 ? fields[1] : 'address';

								column = {
									title: address.title,
									field: key,
									sortable: 'addresses.type_' + type + '.' + field
								};
							} else {
								column = this.props.columnTemplates[key];
							}
							if (column) {
								return (
									<TableTH
										key={'th-' + key}
										column={column}
										tools={tools}
										sort={this.sort}
										currentSorting={this.props.currentSorting}
									/>
								);
							}

							return null;
						}.bind(this)
					)}

					{tools.opts.editable ? (
						<th className={toolsColumnClasses} key="th-edit">
							{hasData && hasExportAction ? (
								hasExport ? (
									<div
										className="th-inner"
										style={{
											paddingRight: '47px',
											fontSize: '18px',
											cursor: 'pointer',
											color: '#4A90E2'
										}}
									>
										<Tooltip
											title={Tools.$translate('default.export') || ''}
											position="left"
											style={{ display: 'block', height: '100%', marginLeft: '-10px' }}
										>
											<b
												data-test-id="file-download"
												className="fa fa-file-excel-o"
												onClick={this.doExport.bind(this, options)}
											/>
										</Tooltip>
									</div>
								) : (
									<div
										className="th-inner"
										style={{
											paddingRight: '47px',
											fontSize: '18px',
											cursor: 'not-allowed',
											color: '#9BAABE'
										}}
									>
										<Tooltip
											title={Tools.$translate('default.noExportRights') || ''}
											position="left"
											style={{ display: 'block', height: '100%', marginLeft: '-10px' }}
										>
											<b data-test-id="file-download" className="fa fa-file-excel-o" />
										</Tooltip>
									</div>
								)
							) : null}
							<div className="th-inner">
								<Tooltip
									title={Tools.$translate('filters.editColumns') || ''}
									position="left"
									style={{ display: 'block', height: '100%', marginLeft: '-10px' }}
								>
									<b
										data-test-id="edit-columns"
										className="fa fa-cog edit-cog"
										onClick={tools.editColumns}
									/>
								</Tooltip>
							</div>
						</th>
					) : (
						<th />
					)}
				</tr>
			</thead>
		);
	}
}

export default TableHead;
